"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("unfetch/polyfill");
require("./array-foreach");
require("./base64");
require("./json");
require("./object-freeze");
require("./object-getownpropertynames");
require("./parentnode-prepend");
require("./promise");
require("./string-repeat");
//# sourceMappingURL=index.js.map